import React from "react";
import { AVATAR_FULL, TEXTURE_BG } from "../lib/constants";
import { Sparkles, Zap, Globe2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { HeroCountdown } from "./Countdown";

export const Hero = ({ onQuickAsk }) => {
  const [q, setQ] = React.useState("");
  const { freeUntil } = useAuth();

  const submit = (e) => {
    e.preventDefault();
    if (q.trim().length < 4) return;
    onQuickAsk(q.trim());
  };

  return (
    <section id="top" className="relative overflow-hidden grain">
      <img
        src={TEXTURE_BG}
        alt=""
        aria-hidden
        className="absolute inset-0 w-full h-full object-cover opacity-[0.06] pointer-events-none"
      />
      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 pt-14 pb-20 lg:pt-20 lg:pb-28">
        <div className="grid lg:grid-cols-[1.15fr_0.85fr] gap-10 lg:gap-6 items-center">
          {/* Left */}
          <div className="fade-up">
            <span className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-clay bg-clay/10 rounded-full px-4 py-2">
              <Sparkles size={14} strokeWidth={2} /> Anonymous AI Advice Character
            </span>

            <h1 className="font-display font-black text-ink text-4xl sm:text-5xl lg:text-6xl leading-[1.05] mt-6">
              Everyday wahala,
              <br />
              <span className="text-clay">answered in seconds.</span>
            </h1>

            <p className="text-base sm:text-lg text-ink/70 mt-6 max-w-xl leading-relaxed">
              Meet <span className="font-bold text-ink">Shabba Robo</span> — your personal support
              and teamwork friend. Bring it. Leave with warm, workable answers.
            </p>

            {/* Quick ask */}
            <form onSubmit={submit} className="mt-8 max-w-xl" data-testid="hero-ask-form">
              <div className="flex flex-col sm:flex-row gap-3 bg-sand-light border border-border rounded-2xl p-2 shadow-[0_8px_30px_rgba(212,93,60,0.08)]">
                <input
                  value={q}
                  onChange={(e) => setQ(e.target.value)}
                  placeholder="Wetin dey worry you? Type it here..."
                  className="flex-1 bg-transparent px-4 py-3 outline-none text-ink placeholder:text-ink/40"
                  data-testid="hero-ask-input"
                />
                <button
                  type="submit"
                  className="rounded-xl bg-clay text-white font-bold px-6 py-3 hover:bg-clay-hover transition-transform hover:-translate-y-0.5 flex items-center justify-center gap-2"
                  data-testid="hero-ask-submit"
                >
                  <Zap size={18} strokeWidth={2.2} /> Get answer
                </button>
              </div>
            </form>

            <div className="flex flex-wrap items-center gap-6 mt-8 text-sm text-ink/60">
              <span className="flex items-center gap-2">
                <Globe2 size={16} className="text-leaf" /> Serving Nigeria &amp; all Africa
              </span>
              <span className="flex items-center gap-2">
                <Zap size={16} className="text-ochre" /> Answers within seconds
              </span>
            </div>

            <HeroCountdown target={freeUntil} />
          </div>

          {/* Right avatar */}
          <div className="fade-up relative flex justify-center" style={{ animationDelay: "0.15s" }}>
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="w-72 h-72 sm:w-96 sm:h-96 rounded-full bg-ochre/25 blur-3xl" />
            </div>
            <div className="relative w-full max-w-sm rounded-[2rem] overflow-hidden border-4 border-sand-light shadow-[0_20px_50px_rgba(26,28,41,0.18)] rotate-1">
              <img
                src={AVATAR_FULL}
                alt="Shabba Robo character"
                className="w-full object-cover"
                data-testid="hero-avatar"
              />
              <span className="absolute bottom-4 left-4 bg-ink/85 backdrop-blur text-sand-light text-xs font-bold uppercase tracking-[0.2em] rounded-full px-4 py-2">
                Shabba Robo
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
